import { APIStatus } from '@application/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { createInterestAsync, deleteInterestAsync, getAllInterestsAsync, getAllInterestsWithoutPaginationAsync, getInterestByIdAsync, updateInterestAsync } from './interestsThunk';
const initialState = {
    status: APIStatus.IDLE,
    interests: null,
    selectedInterest: null,
    interestswithoutpagination: null,
    searchString: null
};
export const interestsSlice = createSlice({
    name: 'interests',
    initialState,
    reducers: {
        resetInterestsApiState(state) {
            state.status = APIStatus.IDLE;
            state.apiError = undefined;
        },
        clearSelectedInterest(state) {
            state.selectedInterest = null;
        },
        resetSearchString(state) {
            state.searchString = null;
        },
        setSearchString(state, action) {
            state.searchString = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            // Get All
            .addCase(getAllInterestsAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllInterestsAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.interests = action.payload;
        })
            .addCase(getAllInterestsAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        })
            // Create
            .addCase(createInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createInterestAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.interests && Array.isArray(state.interests.items) && action.payload.data) {
                state.interests.items.push(action.payload.data);
            }
        })
            .addCase(createInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            // Get By Id
            .addCase(getInterestByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getInterestByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedInterest = action.payload;
        })
            .addCase(getInterestByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            // Update
            .addCase(updateInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateInterestAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.interests && Array.isArray(state.interests.items) && action.payload.data) {
                const data = action.payload.data;
                const index = state.interests.items.findIndex((x) => x.id === data.id);
                if (index !== -1)
                    state.interests.items[index] = data;
                state.selectedInterest = data;
            }
            else {
                if (action.payload.data)
                    state.selectedInterest = action.payload.data;
            }
        })
            .addCase(updateInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        })
            // Delete
            .addCase(deleteInterestAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteInterestAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (state.interests && Array.isArray(state.interests.items) && action.payload.data) {
                const data = action.payload.data;
                state.interests.items = state.interests.items.filter((x) => x.id !== data.id);
            }
        })
            .addCase(deleteInterestAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        }) //Get All Without Pagination
            .addCase(getAllInterestsWithoutPaginationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getAllInterestsWithoutPaginationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.interestswithoutpagination = action.payload;
        })
            .addCase(getAllInterestsWithoutPaginationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            if (action.payload)
                state.apiError = action.payload;
        });
    }
});
export const { resetInterestsApiState, clearSelectedInterest, resetSearchString, setSearchString } = interestsSlice.actions;
export default interestsSlice.reducer;
